import { makeAutoObservable } from "mobx";
import { IRmaResolution } from "../rma-types";
import { RESOLUTION_ID } from "../../../resolutions/constants";
import dashboardSettingsStore from "../../../../stores/dashboard-settings-store";
import { PROFILE_CAPABILITIES } from "../../../../models/ProfileCapabilities";
import translationStore from "../../../../translation/stores/translations-store";

const RESOLUTIONS_TRANSLATION_SCOPE = 'resolutions';

class RmaResolutionStore {
    private _model: IRmaResolution = {} as IRmaResolution;
    
    constructor(model: IRmaResolution) {
        makeAutoObservable(this, {}, {autoBind: true});
        this._setModel(model);
    }
    
    private _setModel(model: IRmaResolution){
        this._model = model;
    }
    
    public get nameKey(): string { return this._model.name ?? ''; }
    public get internalName(): string { return this._model.internal_name; }
    public get resolutionId(): RESOLUTION_ID { return this._model.resolution_id; }
    public get displayLabel(): string {
        const portalTranslations = dashboardSettingsStore.resolveCapability(
            PROFILE_CAPABILITIES.PORTAL_TRANSLATIONS
        );
        if (portalTranslations?.isRefundMethodsScopeSupported === true) {
            const trimmedInternalName = this.internalName?.trim() ?? '';
            return trimmedInternalName !== '' ? trimmedInternalName : this.nameKey;
        }

        const scopeStore = translationStore.loadScope(RESOLUTIONS_TRANSLATION_SCOPE);
        scopeStore.load();
        return scopeStore.getDefaultTranslation(this.nameKey) ?? this.nameKey;
    }
}

export { RmaResolutionStore as default };
